import React from 'react';
import { Sparkles } from 'lucide-react';
import { tx } from '@/translations/translations';

export const SoftTechBanner = ({ language }) => (
  <div className="mb-6 relative overflow-hidden rounded-2xl bg-slate-950">
    <div className="absolute right-0 top-0 w-60 h-60 bg-cyan-500/[0.08] rounded-full blur-[80px] pointer-events-none" />
    <div className="relative px-5 sm:px-8 py-5 flex items-center gap-4">
      <div className="flex items-center gap-1.5 bg-cyan-500 rounded-full px-3 py-1 flex-shrink-0">
        <Sparkles className="w-3 h-3 text-white" />
        <span className="text-[10px] sm:text-xs font-black text-white tracking-wider uppercase">
          {tx(language, 'Nuevo', 'New', 'חדש')}
        </span>
      </div>
      <div className="min-w-0">
        <p className="text-white font-bold text-sm sm:text-base">Soft Tech Wool</p>
        <p className="text-slate-400 text-xs">
          {tx(language, 'Lana que se siente como algodón. Sin picazón, máxima suavidad.', 'Wool that feels like cotton. No itch, maximum softness.', 'צמר שמרגיש כמו כותנה. בלי גירוד, רכות מקסימלית.')}
        </p>
      </div>
    </div>
  </div>
);
